var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.101,
    height: 21.497,
    viewBox: "0 0 24.101 21.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "heart",
    d: "M11.8,21a1.384,1.384,0,0,1-.912-.343c-.953-.834-1.873-1.617-2.684-2.308l0,0a49.91,49.91,0,0,1-5.86-5.5A8.784,8.784,0,0,1,0,7.093,7.377,7.377,0,0,1,1.872,2.055,6.346,6.346,0,0,1,6.593,0,5.936,5.936,0,0,1,10.3,1.28a7.587,7.587,0,0,1,1.5,1.565A7.588,7.588,0,0,1,13.3,1.28,5.936,5.936,0,0,1,17.008,0a6.347,6.347,0,0,1,4.721,2.055A7.376,7.376,0,0,1,23.6,7.093a8.783,8.783,0,0,1-2.341,5.75,49.9,49.9,0,0,1-5.859,5.5c-.812.692-1.733,1.477-2.689,2.313A1.385,1.385,0,0,1,11.8,21ZM6.593,1.383a4.979,4.979,0,0,0-3.7,1.609,6,6,0,0,0-1.506,4.1,7.391,7.391,0,0,0,2.023,4.868A49.115,49.115,0,0,0,9.1,17.291l0,0c.814.694,1.737,1.48,2.7,2.32.966-.841,1.89-1.629,2.706-2.324A49.128,49.128,0,0,0,20.2,11.961a7.392,7.392,0,0,0,2.023-4.868,6,6,0,0,0-1.506-4.1,4.979,4.979,0,0,0-3.7-1.609,4.585,4.585,0,0,0-2.863.991,6.709,6.709,0,0,0-1.6,1.846.873.873,0,0,1-1.5,0,6.7,6.7,0,0,0-1.6-1.846,4.585,4.585,0,0,0-2.862-.991Zm0,0",
    transform: "translate(0.25 0.25)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.cde19c2fc8665684a8a7abf440286e0e.svg";
export { ForwardRef as ReactComponent };